import JSZip from 'jszip';

export const exportToZip = async (editors) => {
    try {
        const zip = new JSZip();
        
        editors.forEach(editor => {
            // Clean filename: replace spaces and special chars
            const fileName = `${editor.heading.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.txt`;
            zip.file(fileName, editor.content || '');
        });
        
        const content = await zip.generateAsync({ type: "blob" });
        const url = URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'text_editors_export.zip';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Export failed:', error);
        alert('Export failed. Please try again.');
    }
};

export const importFromZip = async (file) => {
    try {
        const zip = new JSZip();
        const contents = await zip.loadAsync(file);
        const newEditors = [];
        
        for (const [filename, fileData] of Object.entries(contents.files)) {
            // Nur .txt Dateien und keine Ordner
            if (filename.endsWith('.txt') && !fileData.dir) {
                try {
                    const content = await fileData.async('string');
                    // Extract heading from filename (remove .txt and replace underscores)
                    let heading = filename.replace('.txt', '').replace(/_/g, ' ');
                    // Capitalize first letter of each word
                    heading = heading.split(' ').map(word => 
                        word.charAt(0).toUpperCase() + word.slice(1)
                    ).join(' ');
                    
                    newEditors.push({
                        id: Date.now() + Math.random() * 10000,
                        heading: heading,
                        content: content,
                        isVisible: true,
                        isActive: false
                    });
                } catch (err) {
                    console.error(`Failed to read ${filename}:`, err);
                }
            }
        }
        
        return newEditors;
    } catch (error) {
        console.error('Import failed:', error);
        throw error;
    }
};